export default "__VITE_PUBLIC_ASSET__53b0e527__"